<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useSidebarContext } from './provider';
import Icon from 'next/icon/Icon.vue';
import {
  ROSH_ITEM_BASE,
  ROSH_ITEM_ACTIVE,
  roshItemSize,
} from './roshItemClasses';

// Rosh whitelabel: os agentes de briefing (IA) abrem em rota própria dentro do
// Chatwoot. Ficam numa seção "IA & Ferramentas", junto do Google Workspace.
const { t } = useI18n();
const { accountScopedRoute } = useAccount();
const { isCollapsed } = useSidebarContext();

const agents = computed(() => [
  {
    label: t('SIDEBAR.BRIEFING.QUESTIONADOR'),
    icon: 'i-lucide-clipboard-pen',
    agent: 'questionador',
  },
  {
    label: t('SIDEBAR.BRIEFING.ARQUITETO'),
    icon: 'i-lucide-layout-template',
    agent: 'arquiteto',
  },
]);
</script>

<template>
  <div
    class="flex flex-col gap-1 min-w-0"
    :class="isCollapsed ? 'items-center' : ''"
  >
    <RouterLink
      v-for="a in agents"
      :key="a.agent"
      :to="accountScopedRoute('briefing_agent', { agent: a.agent })"
      :title="a.label"
      :active-class="ROSH_ITEM_ACTIVE"
      :class="[ROSH_ITEM_BASE, roshItemSize(isCollapsed)]"
    >
      <Icon :icon="a.icon" class="flex-shrink-0 size-4 text-n-blue-9" />
      <span v-if="!isCollapsed" class="flex-1 text-sm truncate text-start">
        {{ a.label }}
      </span>
    </RouterLink>
  </div>
</template>
